export default {
    serverError: '何かがうまくいかなかったようです。時間を置いてもう一度お試しください。'
}
